import { constants } from 'helpers/constants';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { listCurrency } from 'store/Orbita/Currency/actions';
import { listCategories } from 'store/Orbita/Product/actions';

import Wizard from './components/Wizard';
import InfoProduct from './InfoProduct';
import PhysicalProduct from './PhysicalProduct';
import ServiceProduct from './ServiceProduct';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  type: number;
}

interface IStates {}

class NewProduct extends Component<IProps, IStates> {
  componentDidMount() {
    const qs = new URLSearchParams(window.location.search).get('type')?.toUpperCase();
    const initialSelected = constants[qs];
    const initialStep = initialSelected ? 2 : 1;

    try {
      this.props.dispatch({ type: 'RESET_PRODUCT_WIZARD_NP' });
      this.props.dispatch({ type: 'RESET_WIZARD_NP', initialStep });
      this.props.dispatch({ type: 'RESET_VALUE_WIZARD_NP', initialSelected });
      this.props.dispatch({ type: 'RESET_PHYSICAL_DELIVERY' });
      this.props.dispatch(listCategories());
      this.props.dispatch(listCurrency());
    } catch (error) {}
  }

  render() {
    const { type } = this.props;
    return (
      <Wizard>
        {type === constants.INFO && <InfoProduct />}
        {type === constants.PHYSICAL && <PhysicalProduct />}
        {type === constants.SERVICE && <ServiceProduct />}
      </Wizard>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    type: state.components.newProductWizard.selected,
  };
}

export default connect(mapStateToProps)(NewProduct);
